import React from "react";
import { AssetIcon } from "../../components/AssetIcon";
import { solanaTokenLabel, type SolanaTokenInfo } from "../../config/solana";

export function SolanaTestTokenNotice({
  token,
}: {
  token?: SolanaTokenInfo | null;
}) {
  if (!token?.testToken) return null;
  return (
    <p className="wallet-review-context" role="note">
      <AssetIcon iconId={token.iconId} symbol={token.symbol} size={24} />{" "}
      {solanaTokenLabel(token)} has no monetary value and can&apos;t be redeemed
      for ZEC.
    </p>
  );
}
